import { ITaskStepsWrapper } from './ITaskStepsWrapper'
import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { TaskStep } from './TaskStep'

export class TaskStepsWrapper extends Entity<ITaskStepsWrapper> {
  @Type(() => TaskStep)
  steps: Array<TaskStep>

  public static new(payload: unknown): TaskStepsWrapper {
    const entity = plainToInstance<TaskStepsWrapper, unknown>(
      TaskStepsWrapper,
      payload,
    )

    return entity
  }
}
